export default "__VITE_ASSET__P6iLsWi___"